// extracted by mini-css-extract-plugin
export default {"img_wrapper":"SimpleOption_img_wrapper__FCmkx","img_overlay":"SimpleOption_img_overlay__kEV18"};